import { useQuery } from 'react-query'
import hooks from '../../../hooks'
import { sortBy } from 'lodash'

const useLocations = () => {
    const { api, endpoints } = hooks.useApi()
    const cacheKeys = hooks.useCacheKeys()

    const { data, isLoading } = useQuery(
        [cacheKeys.LOCATIONS],
        () => api.get(endpoints.locations)
    )

    const locations = sortBy(data || [], [ 'name' ])

    return {
        isLoadingLocations: isLoading,
        locations,
    }
}

export default useLocations